import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { saveAuth } from "@/lib/api";
import { toast } from "sonner";

/**
 * Reads session_id from URL hash (set by Emergent Google OAuth redirect),
 * exchanges it with our backend for a DualQ JWT, saves auth, redirects to dashboard.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleCallback() {
  const loc = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    const hash = loc.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/auth"); return; }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        saveAuth(data);
        toast.success("Signed in with Google");
        // clear hash
        window.history.replaceState({}, document.title, window.location.pathname);
        nav(data.user?.role === "SUPER_ADMIN" ? "/admin" : "/dashboard");
      } catch {
        toast.error("Google sign-in failed");
        nav("/auth");
      }
    })();
  }, [loc.hash, nav]);

  return (
    <div className="min-h-screen grid place-items-center text-slate-400 bg-[#070C18]" data-testid="google-callback">
      Signing you in with Google…
    </div>
  );
}
